export default __webpack_public_path__ + "static/media/insta-6.ae57f0cc.jpg";